export default {"src":"/login-app/[GIT_HASH]/_next/static/media/changed_in_branch.3bd42a99.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};